import './index.less'
import { getProductCouponInfo, } from '@utils/api.js'
import { formatMoney } from '@shopify/theme-currency'
import { copyString, gaProductDetailDataLayer, } from "@utils/index.js"

class ProductCouponNew {
  constructor() {
    this.DOM = document.querySelector('#app-coupon-new')

    const {
      productTitle, variantId, variantPrice, offText, codeText, endsInText, copyAndUseText,
      codeCopySuccessText, couponRulesRichtextText, couponAutoApplied,
    } = this.DOM.dataset

    this.productTitle = productTitle
    this.variantId = variantId
    this.variantPrice = variantPrice
    this.timer = null

    this.i18nText = {
      offText,
      codeText,
      endsInText,
      copyAndUseText,
      codeCopySuccessText,
      couponRulesRichtextText,
      couponAutoApplied,
    }

    this.init()

    // 新 main-product 触发variant变化 - 改变当前变体
    if (document.querySelector('variant-fields')) {
      document.addEventListener('variantChangeEvent', e => {
        const currentVariant = e.detail.variant
        if (currentVariant) {
          this.variantId = currentVariant.id
          this.variantPrice = currentVariant.price

          setTimeout(() => {
            this.timer && clearTimeout(this.timer)
            this.init()

          }, 200)
        }
      })
    }
  }
  async init() {
    try {
      const { data, } = await getProductCouponInfo({ skuId: this.variantId, })

      if (data) {
        const { api, cr, shopId, } = window.pageInfo
        // 获取服务器时间
        const url = `${api}/osconsumerapi/v1/com/get-server-time?shopify_shop_id=${shopId || ''}&cr=${cr || ''}`
        const response = await fetch(url, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          headers: { "Content-Type": "application/json", },
        });
        const { data: { datetime }, } = await response.json();
        const serverTime = new Date(datetime).getTime()

        const { code, couponAmountShowType, showCountDown, value, valueType, startDate, endDate, discountScope, } = data;

        // 如果服务端时间，大于 结束时间，则直接 return
        if (serverTime < new Date(startDate).getTime() || serverTime >= new Date(endDate).getTime()) {
          // 清空DOM
          this.DOM.innerHTML = ''
          this.DOM.parentElement.setAttribute('data-show', false)
          return
        }

        // 显示倒计时
        if (showCountDown === 1 && endDate) {
          this.DOM.innerHTML = this.renderCountdownDOM(code, couponAmountShowType, value, valueType)
          this.DOM.parentElement.style.display = 'block'
          this.DOM.parentElement.setAttribute('data-show', true)

          this.countdownDOM = this.DOM.querySelector('[data-count-down]')

          // 渲染数据
          this.initCountdownData({
            serverTime,
            startTime: new Date(startDate).getTime(),
            endTime: new Date(endDate).getTime(),
          })
        } else {
          this.DOM.innerHTML = this.renderDefaultDOM(code, couponAmountShowType, value, valueType)
          this.DOM.parentElement.style.display = 'block'
          this.DOM.parentElement.setAttribute('data-show', true)
        }

        this.toggleCouponDisplay.call(this, discountScope);

        // 注册 copy and use 按钮事件
        this.DOM.querySelector('[data-copy-and-use]').onclick = () => {
          copyString(code, () => {
            // 提示 copy 成功
            pushSuccessMessage(this.i18nText.codeCopySuccessText)

            // 数据埋码
            gaProductDetailDataLayer({
              "product_spu_name": this.productTitle, //识别页面产品spu标题名称text
              "module": "Regular Coupons",//固定模块命名Regular Coupons
              "position": this.DOM.querySelector('h4').innerText, // 识别优惠券标题text
              "button_name": this.i18nText.copyAndUseText, // 识别按钮文字text，根据按钮实际文案而定
              "content": code, // 识别优惠券的券码text
              "status": window.pageInfo.customerInfo.id ? 'logged_in' : 'tourist', // 登录状态识别，已登录为logged_in，游客为tourist
            })
          })
        }

        // 注册 tips 按钮事件
        if (this.DOM.querySelector('[data-coupon-tips-btn]')) {
          this.DOM.querySelector('[data-coupon-tips-btn]').onclick = () => {
            // 替换为 <img> 标签
            const popupHtml = this.i18nText.couponRulesRichtextText.replace(/!\[.*?\]\((.*?)\)/g, (match, url) => {
              return `<img src="${url}" alt="coupon rules image" loading="lazy"/>`;
            })

            window.ZModle.getInstance(popupHtml, {
              id: `app-coupon-new-rules-popup-${this.variantId}`,
              class: "app-coupon-new-rules-popup-wrap",
              cb: () => {

              }
            })
          }
        }
      } else {
        // 清空DOM
        this.DOM.innerHTML = ''
        this.DOM.parentElement.style.display = 'none'
        this.DOM.parentElement.setAttribute('data-show', false)
      }
    } catch (err) {
      // 清空DOM
      this.DOM.innerHTML = ''
      this.DOM.parentElement.style.display = 'none'
      this.DOM.parentElement.setAttribute('data-show', false)
    }
  }
  // 处理金额格式化，如果小数点后两位都是0，则去掉小数部分
  formatCouponMoney(money, moneyFormat) {
    const formattedMoney = formatMoney(money, moneyFormat)
    // 检查是否以.00结尾（考虑不同货币符号的位置）
    return formattedMoney.replace(/(\.00)(?=[^0-9]*$)/, '')
  }

  // 自动折扣优惠券样式，discountScope值为1点击选择，值为2自动折扣
  toggleCouponDisplay(discountScope) {
    const copyBlocks = this.DOM.querySelectorAll('.copy-and-use');
    const autoAppliedBlocks = this.DOM.querySelectorAll('.code-text-applied');
    const couponCodeBlocks = this.DOM.querySelectorAll('.coupon-code-text');
    const shouldShowCopy = discountScope === 1;
    const shouldShowApplied = discountScope === 2;

    copyBlocks.forEach(el => {
      el.style.display = shouldShowCopy ? '' : 'none';
    });

    couponCodeBlocks.forEach(el => {
      el.style.display = shouldShowCopy ? '' : 'none';
    });

    autoAppliedBlocks.forEach(el => {
      el.style.display = shouldShowApplied ? '' : 'none';
    });
  }
  renderCountdownDOM(code, couponAmountShowType, value, valueType) {
    const moneyFormat = window?.pageInfo?.currency?.money_format
    const couponValue =
      couponAmountShowType === 0
        ?
          valueType === 0 ? this.formatCouponMoney(value * 100, moneyFormat) : `${value}%`
        :
          valueType === 0 ? this.formatCouponMoney(value * 100, moneyFormat) : this.formatCouponMoney(value * this.variantPrice / 100, moneyFormat)

    const isBreakLine = this.getOffTextClass(couponValue)
    return `
      <div
        class="
          flex-between flex-row relative
          w-full max-w-654 h-180 rounded-20 pl-15 pr-10
          lg:j-max-w-500 lg:j-h-100 lg:j-rounded-8 lg:j-pl-15 lg:j-pr-10
          xl:a-max-w-500 xl:a-h-100 xl:a-rounded-8 xl:a-pl-15 xl:a-pr-10
          before:block before:content-[''] before:w-26 before:h-48 before:lg:j-w-16 before:lg:j-h-28 before:xl:a-w-16 before:xl:a-h-28 before:bg-white before:rounded-none before:rounded-tr-28 before:rounded-br-28 before:lg:j-rounded-tr-14 before:xl:a-rounded-br-14 before:xl:a-rounded-tr-14 before:lg:j-rounded-br-14
          before:absolute before:z-1 before:left-0 before:top-1/2 before:-translate-y-1/2
          after:block after:content-[''] after:w-26 after:h-48 after:lg:j-w-16 after:lg:j-h-28 after:xl:a-w-16 after:xl:a-h-28 after:bg-white after:rounded-none after:rounded-tl-28 after:rounded-bl-28 after:lg:j-rounded-tl-14 after:lg:j-rounded-bl-14 after:xl:a-rounded-tl-14 after:xl:a-rounded-bl-14
          after:absolute after:z-1 after:right-0 after:top-1/2 after:-translate-y-1/2 coupon-box
        "
        style="background: linear-gradient( 272deg, #FD5000 0%, #FF710A 100%);"
      >
        <div class="flex-center flex-col w-363 gap-y-12 lg:j-w-278 lg:j-gap-y-6 xl:a-w-278 xl:a-gap-y-6">
          <h4 class="flex gap-y-4 text-#FFFEF4 font-600 leading-none text-64 lg:j-text-44 xl:a-text-44 discount-size ${isBreakLine ? 'break-box' : ''}"><span>${couponValue}</span><span class="${isBreakLine ? 'break-line' : ''}">&nbsp;${this.i18nText.offText}</span></h4>
          <div class="w-full flex-center" data-count-down>
            <span class="text-white text-20 mr-10 lg:j-text-12 lg:j-mr-10 xl:a-text-12 xl:a-mr-10">${this.i18nText.endsInText}</span>
            <span class="inline-flex items-center justify-center font-500 min-w-38 h-35 rounded-6 text-22 px-4 lg:j-min-w-26 lg:j-h-24 lg:j-rounded-4 lg:j-text-14 lg:j-px-4 xl:a-min-w-26 xl:a-h-24 xl:a-rounded-4 xl:a-text-14 xl:a-px-4 bg-#FFFEF4 text-primary leading-none opacity-50"></span>
            <span class="mx-10 text-22 lg:j-mx-6 lg:j-text-14 xl:a-mx-6 xl:a-text-14 text-white font-500 opacity-50">:</span>
            <span class="inline-flex items-center justify-center font-500 min-w-38 h-35 rounded-6 text-22 px-4 lg:j-min-w-26 lg:j-h-24 lg:j-rounded-4 lg:j-text-14 lg:j-px-4 xl:a-min-w-26 xl:a-h-24 xl:a-rounded-4 xl:a-text-14 xl:a-px-4 bg-#FFFEF4 text-primary leading-none opacity-50"></span>
            <span class="mx-10 text-22 lg:j-mx-6 lg:j-text-14 xl:a-mx-6 xl:a-text-14 text-white font-500 opacity-50">:</span>
            <span class="inline-flex items-center justify-center font-500 min-w-38 h-35 rounded-6 text-22 px-4 lg:j-min-w-26 lg:j-h-24 lg:j-rounded-4 lg:j-text-14 lg:j-px-4 xl:a-min-w-26 xl:a-h-24 xl:a-rounded-4 xl:a-text-14 xl:a-px-4 bg-#FFFEF4 text-primary leading-none opacity-50"></span>
            <span class="mx-10 text-22 lg:j-mx-6 lg:j-text-14 xl:a-mx-6 xl:a-text-14 text-white font-500 opacity-50">:</span>
            <span class="inline-flex items-center justify-center font-500 min-w-38 h-35 rounded-6 text-22 px-4 lg:j-min-w-26 lg:j-h-24 lg:j-rounded-4 lg:j-text-14 lg:j-px-4 xl:a-min-w-26 xl:a-h-24 xl:a-rounded-4 xl:a-text-14 xl:a-px-4 bg-#FFFEF4 text-primary leading-none opacity-50"></span>
          </div>
        </div>

        <!-- 分割线 -->
        <div class="w-0 h-86 lg:j-h-60 xl:a-h-60 border-dashed border-#FFFEF4/70 border-[1px]"></div>

        <div class="flex-1 flex-center flex-col">
          <div class="flex-1 flex-center flex-col gap-y-24 lg:j-gap-y-10 xl:a-gap-y-10 copy-and-use">
            <span class="text-#FFFEF4 leading-none font-600 text-22 lg:j-text-14 xl:a-text-14 code-text">${this.i18nText.codeText}:${code}</span>
            <button
              class="bg-#FFFEF4 font-500 text-primary px-18 text-24 h-56 max-w-220 leading-none rounded-full lg:j-text-16 lg:w-fit lg:j-max-w-160 lg:j-px-15 lg:j-h-36 xl:a-max-w-160 xl:a-text-16 xl:a-px-15 xl:a-h-36 button-text"
              data-copy-and-use
            >${this.i18nText.copyAndUseText}</button>
          </div>
          <div class="text-#FFFEF4 leading-none font-500 text-28 lg:j-text-16 xl:a-text-16 code-text-applied">
            ${this.i18nText.couponAutoApplied}
          </div>
        </div>

        ${
          this.i18nText.couponRulesRichtextText
            ? `
              <button class="absolute right-16 top-8 lg:j-top-6 lg:j-right-12 xl:a-top-6 xl:a-right-12 bg-transparent opacity-80 coupon-svg" data-coupon-tips-btn>
                ${this.renderTipSVG()}
              </button>
            `
            : ''
        }
      </div>
    `
  }
  renderDefaultDOM(code, couponAmountShowType, value, valueType) {
    const moneyFormat = window?.pageInfo?.currency?.money_format
    const couponValue =
      couponAmountShowType === 0
        ?
          valueType === 0 ? this.formatCouponMoney(value * 100, moneyFormat) : `${value}%`
        :
          valueType === 0 ? this.formatCouponMoney(value * 100, moneyFormat) : this.formatCouponMoney(value * this.variantPrice / 100, moneyFormat)

    const isBreakLine = this.getOffTextClass(couponValue)
    return `
      <div
        class="
          flex-between flex-row relative
          w-full max-w-654 h-180 rounded-20 pl-15 pr-10
          lg:j-max-w-500 lg:j-h-100 lg:j-rounded-8 lg:j-pl-15 lg:j-pr-10
          xl:a-max-w-500 xl:a-h-100 xl:a-rounded-8 xl:a-pl-15 xl:a-pr-10
          before:block before:content-[''] before:w-26 before:h-48 before:lg:j-w-16 before:lg:j-h-28 before:xl:a-w-16 before:xl:a-h-28 before:bg-white before:rounded-none before:rounded-tr-28 before:rounded-br-28 before:lg:j-rounded-tr-14 before:xl:a-rounded-br-14 before:xl:a-rounded-tr-14 before:lg:j-rounded-br-14
          before:absolute before:z-1 before:left-0 before:top-1/2 before:-translate-y-1/2
          after:block after:content-[''] after:w-26 after:h-48 after:lg:j-w-16 after:lg:j-h-28 after:xl:a-w-16 after:xl:a-h-28 after:bg-white after:rounded-none after:rounded-tl-28 after:rounded-bl-28 after:lg:j-rounded-tl-14 after:lg:j-rounded-bl-14 after:xl:a-rounded-tl-14 after:xl:a-rounded-bl-14
          after:absolute after:z-1 after:right-0 after:top-1/2 after:-translate-y-1/2
          coupon-box
        "
        style="background: linear-gradient( 272deg, #FD5000 0%, #FF710A 100%);"
      >
        <div class="flex-center flex-col w-363 gap-y-12 lg:j-w-278 lg:j-gap-y-6 xl:a-w-278 xl:a-gap-y-6">
          <h4 class="flex gap-y-4 text-#FFFEF4 font-600 leading-none text-64 lg:j-text-44 xl:a-text-44 discount-size ${isBreakLine ? 'break-box' : ''}"><span>${couponValue}</span><span class="${isBreakLine ? 'break-line' : ''}">&nbsp;${this.i18nText.offText}</span></h4>
          <span class="text-#FFFEF4 leading-none mt-4 lg:mt-0 coupon-code-text">${this.i18nText.codeText}:${code}</span>
        </div>

        <!-- 分割线 -->
        <div class="w-0 h-86 lg:j-h-60 xl:a-h-60 border-dashed border-#FFFEF4/70 border-[1px]"></div>

        <div class="flex-1 flex-center flex-col gap-y-24 lg:j-gap-y-10 xl:a-gap-y-10">
          <button
            class="bg-#FFFEF4 font-500 text-primary px-18 text-24 h-64 max-w-220 leading-none rounded-full lg:j-text-16 lg:w-fit lg:j-max-w-160 lg:j-px-15 lg:j-h-40 xl:a-max-w-160 xl:a-text-16 xl:a-px-15 xl:a-h-40 button-text copy-and-use"
            data-copy-and-use
          >${this.i18nText.copyAndUseText}</button>
          <div class="text-#FFFEF4 leading-none font-500 text-28 lg:j-text-16 xl:a-text-16 code-text-applied">
            ${this.i18nText.couponAutoApplied}
          </div>
        </div>

        ${
          this.i18nText.couponRulesRichtextText
            ? `
              <button class="absolute right-16 top-8 lg:j-top-6 lg:j-right-12 xl:a-top-6 xl:a-right-12 bg-transparent coupon-svg" data-coupon-tips-btn>
                ${this.renderTipSVG()}
              </button>
            `
            : ''
        }
      </div>
    `
  }
  getOffTextClass(couponValue) {
    const { cr } = window.pageInfo
    const isBreakLine = (() => {
      // 对于fr站点，只要有couponValue就换行
      if (cr === 'FR') return true
      // 对于de站点，couponValue超过1位数就换行
      if (cr === 'DE') return couponValue.replace(/[^0-9]/g, '').length > 1
      // 对于us/ca/uk/eu/jp站点，当couponValue超过4位数时换行
      if (['US', 'CA', 'UK', 'EU', 'JP'].includes(cr)) return couponValue.replace(/[^0-9]/g, '').length > 4
      return false
    })()
    return isBreakLine
  }

  renderTipSVG() {
    return `
      <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.900000036">
          <g transform="translate(-1292.000000, -334.000000)" fill="#FFFEF4" fill-rule="nonzero">
            <g transform="translate(1292.000000, 334.000000)">
              <path d="M8,16 C3.582,16 0,12.418 0,8 C0,3.582 3.582,0 8,0 C12.418,0 16,3.582 16,8 C16,12.418 12.418,16 8,16 Z M8,14.6666667 C11.682,14.6666667 14.6666667,11.682 14.6666667,8 C14.6666667,4.318 11.682,1.33333333 8,1.33333333 C4.318,1.33333333 1.33333333,4.318 1.33333333,8 C1.33333333,11.682 4.318,14.6666667 8,14.6666667 Z M8,6.66666666 C8.4418278,6.66666666 8.8,6.96514349 8.8,7.33333333 C8.8,8.14832097 8.8,8.75733823 8.8,9.16038513 C8.8,9.79437527 8.8,10.7409136 8.8,12 C8.8,12.3681898 8.4418278,12.6666667 8,12.6666667 C7.5581722,12.6666667 7.2,12.3681898 7.2,12 L7.2,7.33333333 C7.2,6.96514349 7.5581722,6.66666666 8,6.66666666 Z M7.93333333,5.2 C7.41786756,5.2 6.99999999,4.78213243 6.99999999,4.26666666 C6.99999999,3.7512009 7.41786756,3.33333333 7.93333333,3.33333333 C8.4487991,3.33333333 8.86666666,3.7512009 8.86666666,4.26666666 C8.86666666,4.78213243 8.4487991,5.2 7.93333333,5.2 L7.93333333,5.2 Z" id="形状"></path>
            </g>
          </g>
        </g>
      </svg>
    `
  }

  // 倒计时初始化
  async initCountdownData({ serverTime, startTime, endTime, }) {
    if (serverTime >= startTime) {
      this.tick(endTime, serverTime)
    } else {
      // 移除DOM
      this.DOM.parentElement.removeChild(this.DOM)
    }
  }
  // 倒计时 span
  renderCountdownSpan(days, hours, minutes, seconds) {
    const numberStyle = 'inline-flex items-center justify-center font-500 min-w-38 h-35 rounded-6 text-22 px-4 lg:j-min-w-26 lg:j-h-24 lg:j-rounded-4 lg:j-text-14 lg:j-px-4 xl:a-min-w-26 xl:a-h-24 xl:a-rounded-4 xl:a-text-14 xl:a-px-4 bg-#FFFEF4 text-primary leading-none'
    const colonStyle = 'mx-10 text-22 lg:j-mx-6 lg:j-text-14 xl:a-mx-6 xl:a-text-14 text-white font-500'

    return `
      <span class="text-white text-20 mr-10 lg:j-text-12 lg:j-mr-10 xl:a-text-12 xl:a-mr-10">${this.i18nText.endsInText}</span>
      <span class="${numberStyle}">${days || ''}</span>
      <span class="${colonStyle}">:</span>
      <span class="${numberStyle}">${hours || ''}</span>
      <span class="${colonStyle}">:</span>
      <span class="${numberStyle}">${minutes || ''}</span>
      <span class="${colonStyle}">:</span>
      <span class="${numberStyle}">${seconds || ''}</span>
    `
  }
  tick(target, current) {
    const leftTime = (target - current) / 1000
    let days, hours, minutes, seconds

    if (leftTime <= 0) {
      this.timer && clearTimeout(this.timer)

      // 移除 DOM
      this.DOM.parentElement.removeChild(this.DOM)
    } else {
      days = String(parseInt(leftTime / 60 / 60 / 24)).padStart(2, '0')
      hours = String(parseInt(leftTime / 60 / 60 % 24)).padStart(2, '0')
      minutes = String(parseInt(leftTime / 60 % 60)).padStart(2, '0')
      seconds = String(parseInt(leftTime % 60)).padStart(2, '0')

      this.countdownDOM.innerHTML = this.renderCountdownSpan(days, hours, minutes, seconds)

      this.timer = setTimeout(() => this.tick(target, current + 1000), 1000)
    }
  }
}


document.addEventListener('DOMContentLoaded', () => {
  // 新优惠券
  new ProductCouponNew()
})
